// Copyright (c) 2025, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import React from "react";
import { Switch } from "@blueprintjs/core";

const ExamResumptionConfig = ({ data, onToggle }) => {
  return (
    <div className="content">
      <div className="card">
        <div className={"header"}>
          <div className="pull-left">
            <h5 className="title" style={{ marginBottom: "5px" }}>
              Exam Settings
            </h5>
            <p className="category">Manage exam settings</p>
          </div>
        </div>
        <div className="clearfix" />
        <div
          style={{
            padding: "30px 45px",
          }}
          className={"content"}
        >
          <div className="settings-content">
            <Switch
              innerLabelChecked="on"
              innerLabel="off"
              className="custom-switch"
              checked={data.isExamResumptionEnabled}
              label={
                <>
                  Enable Exam Resumption{" "}
                  <span
                    style={{
                      color: "#ff9800",
                      marginLeft: "8px",
                    }}
                  >
                    (Experimental Feature)
                  </span>
                </>
              }
              onChange={() => onToggle("isExamResumptionEnabled")}
              alignIndicator="right"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExamResumptionConfig;
